import React, {Component} from 'react';
import ReactToPrint from 'react-to-print';
import CreditCardTransactionReportsFilter from '../components/CreditCardTransactionReportsFilter';
import CreditCardTransactionReport from '../components/CreditCardTransactionReport';
import ReportHeaderState from '../components/ReportHeaderState';
import NoAccess from '../noAccess';
import {getTimeZoneOffsetDefault} from '../shared/dateTimeLists';
import {hasReportsAccess} from '../shared/authFunctions';
import FuseTheme from '../global/theme';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {commonStyles} from '../shared/styles';
import {Card, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/action/credit-card';

export const fuseCreditCardTransactionReportsIcon = Icon;

const styles = {
    button: {color: FuseTheme.palette.primary3Color},
    error: {fontSize: 16, color: FuseTheme.palette.errorColor},
    reportHeader: {
        position: 'relative',
        backgroundColor: FuseTheme.palette.accent2Color,
        margin: '0 0 5px 0',
        padding: '1em'
    },
    reportHeaderTitle: {margin: '0 0 1em 0'},
    bold: {fontWeight: 600}
};

/**
 * Credit Card Transaction Search Reports class for retrieving and displaying summary
 *
 */
export class CreditCardTransactionReports extends Component {
    constructor(props) {
        super(props);
        const system = localStorage.getItem('system');
        const offsetDefault = getTimeZoneOffsetDefault();
        this.state = {
            errorMessage: null,
            selectedAmount: null,
            selectedLastFour: null,
            selectedEndDate: null,
            selectedStartDate: null,
            selectedOffset: offsetDefault,
            summaryComplete: false,
            system: system,
        };
    }

    handleFilterSubmit = (values) => {
        this.setState({
            selectedLastFour: values.lastFour,
            selectedAmount: values.amount,
            selectedStartDate: values.startDate,
            selectedEndDate: values.endDate,
            selectedOffset: values.offset
        });
    };

    /**
     * Handle event props for Detailed Credit Card Transaction table completion
     *
     * @param isComplete
     */
    handleSummaryComplete = (isComplete) => {
        this.setState({
            summaryComplete: isComplete,
        });
    };

    handleReportError = (message) => {
        this.setState({
            errorMessage: message,
            summaryComplete: true,
        });
    };

    render() {
        const {
            errorMessage,
            selectedAmount,
            selectedLastFour,
            selectedEndDate,
            selectedStartDate,
            selectedOffset,
            summaryComplete,
            system
        } = this.state;

        if (!hasReportsAccess()) return <NoAccess/>;

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Credit Card Transaction Search Reports</span>;

        const ListDescription = () => {
            return (
                <span className="list-description hide-print">
                    <p>A Credit Card Transaction Search Report displays a list of Sales Transactions, to
                        identify transactions for possible chargeback.</p>
                    <p>Select a date range, enter the last 4 digits of a credit card, and enter a valid
                        amount (in dollars and cents) to view transactions.</p>
                </span>
            );
        };

        return (
            <div className="lists-container" ref={e => (this.printReportRef = e)}>
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        {/* Report Filter (Start Date, End Date, Time Zone, Last Four, Amount) */}
                        <CreditCardTransactionReportsFilter onSubmit={(e) => this.handleFilterSubmit(e)}/>

                        {/* Print Header */}
                        {selectedStartDate && selectedEndDate && selectedOffset && selectedLastFour &&
                            <ReportHeaderState
                                reportType="Credit Card Transaction Report Summary"
                            />
                        }

                        {/* Credit Card Transaction Report Content */}
                        {selectedStartDate && selectedEndDate && selectedOffset && selectedLastFour &&
                            <div>

                                {/* Report Header, Loader, and messaging */}
                                <div style={styles.reportHeader}>
                                    <div className="btn-print-container report-header-button-container">
                                        <ReactToPrint
                                            trigger={() =>
                                                <RaisedButton
                                                    primary
                                                    type="button"
                                                    label="Print Report"
                                                    style={styles.button}
                                                />
                                            }
                                            content={() => this.printReportRef}
                                        />
                                    </div>
                                    <h2 style={styles.reportHeaderTitle}>Credit Card Transaction Search Report</h2>
                                </div>
                                {!summaryComplete &&
                                    <div style={commonStyles.loaderContainer}>
                                        <h4>Generating Report...</h4>
                                        <CircularProgress
                                            size={24}
                                            thickness={2}
                                            style={commonStyles.loader}
                                        />
                                    </div>
                                }

                                {/* Summary Report */}
                                <CreditCardTransactionReport
                                    startDate={selectedStartDate}
                                    endDate={selectedEndDate}
                                    offset={selectedOffset}
                                    lastFour={selectedLastFour}
                                    amount={selectedAmount}
                                    onSummaryComplete={this.handleSummaryComplete}
                                    onError={this.handleReportError}
                                    system={system}
                                />
                            </div>
                        }

                        {/* Error and Messaging */}
                        {errorMessage &&
                            <div style={styles.error}>
                                <p>{errorMessage}</p>
                            </div>
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Report/CreditCardTransactionReports.js